import { render, staticRenderFns } from "./flowWidget.vue?vue&type=template&id=b4381002&scoped=true"
import script from "./flowWidget.vue?vue&type=script&lang=js"
export * from "./flowWidget.vue?vue&type=script&lang=js"
import style0 from "./flowWidget.vue?vue&type=style&index=0&id=b4381002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4381002",
  null
  
)

export default component.exports